<div class="container">
    <!-- Input Section Card -->
    <div class="card p-3 mb-3">
        <h4>Psychometric Examination Report Generator</h4>

        <form (ngSubmit)="fetchReport()">
            <!-- Error/Warning Messages -->
            <div class="d-flex justify-content-center mb-3 text-danger" *ngIf="!exam || !exam.id">
                <p>No examination selected. You will be redirected to the examinations page.</p>
            </div>

            <!-- Examination Info -->
            <div class="row" *ngIf="exam && exam.id">
                <div class="col mb-3">
                    <div class="alert alert-info mb-0">
                        <strong>Examination:</strong> {{ exam.examinationName|| '#' + exam.id }}
                    </div>
                </div>
            </div>

            <!-- Candidate List -->
            <div class="row">
                <div *ngIf="psychometricReport.examinationScheduleID == null" class="mb-3 col-md-6">
                    <label class="form-label">Candidate Number List</label>
                    <textarea class="form-control" rows="3" [(ngModel)]="psychometricReport.candidateIDs"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Enter candidate numbers (comma or newline separated)"
                        [disabled]="!exam || !exam.id">
          </textarea>
                    <small class="text-muted">Leave empty to generate report for all candidates</small>
                </div>

                <!-- Consistency Threshold Percentage -->
                <div class="mb-3"
                    [ngClass]="psychometricReport.examinationScheduleID == null ? 'col-md-6' : 'col-md-12'">

                    <label class="form-label">Consistency Threshold (%)</label>
                    <input type="number" class="form-control"
                        [(ngModel)]="psychometricReport.consistencyThresholdPercentage"
                        [ngModelOptions]="{ standalone: true }" min="0" max="100" placeholder="70"
                        [disabled]="!exam || !exam.id">
                    <small class="text-muted">Minimum consistency score for valid results (0-100)</small>
                </div>
            </div>

            <!-- Checkboxes -->
            <div class="row">
                <div class="col-md-6">
                    <div class="custom-checkbox">
                        <input id="hideConsistencyChecks" type="checkbox" class="custom-control-input"
                            [(ngModel)]="psychometricReport.hideConsistencyChecks"
                            [ngModelOptions]="{ standalone: true }" [disabled]="!exam || !exam.id">
                        <label class="custom-control-label" for="hideConsistencyChecks">
                            Hide Consistency Checks in Report
                        </label>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="custom-checkbox">
                        <input id="skipImport" type="checkbox" class="custom-control-input"
                            [(ngModel)]="psychometricReport.skipImportCandidateData"
                            [ngModelOptions]="{ standalone: true }" [disabled]="!exam || !exam.id">
                        <label class="custom-control-label" for="skipImport">
                            Skip Import Candidate Data
                        </label>
                    </div>
                </div>
            </div>

            <hr />

            <!-- Action Button -->
            <div class="row mt-3">
                <div class="col-8 text-center mx-auto">
                    <input class="form-control bg-primary text-white" type="submit" value="Fetch Report"
                        [disabled]="isGenerating || !exam || !exam.id" />
                </div>
            </div>

            <!-- Loading Indicator -->
            <div class="row mt-3" *ngIf="isGenerating">
                <div class="col text-center">
                    <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <p class="mt-2">Generating psychometric report, please wait...</p>
                </div>
            </div>
        </form>
    </div>

    <!-- Report Display Card -->
    <div class="card p-3" *ngIf="showReport || noReportFound || (!isGenerating && !showReport && !noReportFound)">
        <!-- Report Content -->
        <div *ngIf="showReport && html && !isGenerating" id="report">
            <div class="headercontainer"></div>
            <div id="questionscontainer" [innerHTML]="html | safeHtml"></div>
            <button id="printPageBtn" class="print-btn" (click)="printReport()">
                Download
            </button>
        </div>

        <!-- No Report Found -->
        <div *ngIf="noReportFound && !isGenerating" class="empty-message text-center">
            <i class="fas fa-exclamation-circle fa-3x text-warning mb-3"></i>
            <h5>No Report Found</h5>
            <p>Unable to generate the psychometric report. Please check your parameters and try again.</p>
        </div>

        <!-- Initial State -->
        <div *ngIf="!showReport && !noReportFound && !isGenerating" class="empty-message text-center">
            <i class="fas fa-chart-line fa-3x text-muted mb-3"></i>
            <h5>Ready to Generate Report</h5>
            <p>Configure the parameters above and click "Fetch Report" to generate the psychometric assessment report.
            </p>
        </div>
    </div>
</div>